<template>
  <v-card
    :color="cardColor"
    :style="`color: ${textColor}`"
    class="order-card"
    :min-height="(isManager || isDirector) ? '160px' : '135px'"
    ripple
    height="fit-content"
    @click="$router.push(`/pedido/${encodedId}`)"
  >
    <v-card-title class="order-card__title mb-3">
      Pedido n° {{ orderId }}
      <v-icon
        v-if="order.resolved"
        color="#6ADDC8"
        medium
      >
        $vuetify.icons.checkIcon
      </v-icon>
    </v-card-title>
    <v-card-text class="order-card__content">
      Telefone do cliente: {{ order.fullNumber }}<br>
      Total da compra: R${{ order.cart.totalPrice.toLocaleString() }}<br>
      {{ (isManager || isDirector) ? `Vendedor: ${order.sellerName}` : '' }}
      <v-icon
        :color="textColor"
        small
        style="align-items: end;"
      >
        mdi-arrow-right
      </v-icon>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['isManager', 'isDirector']),
    textColor() {
      return this.order.resolved ? '#8A8691' : '#140C22';
    },
    cardColor() {
      return this.order.resolved ? '#EEE' : '#FFF';
    },
    orderId() {
      const sanitazedId = this.order._id.match(/[^\D0]+/g).join('');
      return `${sanitazedId.slice(0, 3)}${sanitazedId.slice(-3)}`;
    },
    encodedId() {
      return btoa(this.order._id);
    },
  },
};

</script>

<style lang="scss" scoped>
.order-card {
  font-family: 'Nunito Sans';
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
  &__title {
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    padding: 0;
    font-size: 16px;
  }
  &__content {
    display: flex;
    justify-content: space-between;
    padding: 0;
    font-size: 14px;
  }
}
</style>
